import { Box, Flex, Paper } from '@mantine/core';
import { IconAlertOctagon } from '@tabler/icons-react';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  bg?: string;
};

export const ErrorCard = ({ children, bg }: Props) => {
  return (
    <Paper
      px="xs"
      py="xxs"
      bg={bg}
      style={{
        borderRadius: 12,
        borderStyle: 'solid',
        borderColor: 'var(--mantine-color-error-6)',
        borderWidth: 1,
      }}
    >
      <Flex direction="row" align={'center'}>
        <IconAlertOctagon size={'24px'} stroke={1} color={'var(--mantine-color-error-6)'} />
        <Box ml={'xxs'}>{children}</Box>
      </Flex>
    </Paper>
  );
};
